import {
  companyPartnerIntegrationsService,
  RegisterCompanyPartnerIntegrationRequest,
} from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useRegisterIntegration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: RegisterCompanyPartnerIntegrationRequest) =>
      companyPartnerIntegrationsService.register(body),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCompanyIntegrations', data.companyId] });
    },
  });
};

export default useRegisterIntegration;
